import { create } from 'zustand';

export const useGlobalStore = create((set, get) => ({
  editItem: false,
  setEditItem: value => set({ editItem: value }),
  isExistVideo: undefined,
  setIsExistVideo: value => set({ isExistVideo: value }),
  cancelUpload: false,
  setCancelUpload: value => set({ cancelUpload: value }),
  uploadIsLoading: false,
  setUploadIsLoading: value => set({ uploadIsLoading: value }),
  refreshData: 0,
  setRefreshData: value => {
    if (typeof value === 'function') {
      set({ refreshData: value(get().refreshData) });
    } else if (value === undefined) {
      set({ refreshData: get().refreshData + 1 });
    } else {
      set({ refreshData: value });
    }
  },
}));
